var path = 'directives/userimage.html';
var html = "<div class=\"userimage-wrap u-circle\" data-trustlevel={{userData.trustLevel}} data-trust-hint> <img class=\"userimage-picture u-circle\" data-ng-src={{userData.basic.image}} alt={{userData.name}} /> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./views/directives/userimage.html
// module id = YnzV
// module chunks = 1 2